$(document).ready(function () {
    // $('#page').fullpage({
    //     lockAnchors: true,
    //     recordHistory: false,
    //     verticalCentered: false,
    //     lazyLoading: true,
    //     afterRender: function () {
    //     },
    //
    //     afterResize: function () {
    //     },
    //     onLeave: function (index, nextIndex, direction) {
    //     },
    // });
    //
    //
    // $.fn.fullpage.setAllowScrolling(true);
});